import React, { useEffect} from "react";
import { BiPlusCircle } from "react-icons/bi";
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Breadcrumb from "../common/Breadcrumb";

const Auditorium = () => {  

  const images = [
    { id: 1, src: "images/gallery/auditorium-1.png", alt: "Auditorium", title: "Auditorium", group: "Auditorium" },
    { id: 2, src: "images/gallery/auditorium-2.png", alt: "Auditorium 1", title: "Auditorium", group: "Auditorium" },
    { id: 3, src: "images/gallery/auditorium-3.png", alt: "Auditorium 2", title: "Auditorium", group: "Auditorium" },
    { id: 4, src: "images/gallery/Auditorium-4.png", alt: "Auditorium", title: "Auditorium", group: "Auditorium" },
    { id: 5, src: "images/gallery/Auditorium-5.png", alt: "Auditorium", title: "Auditorium", group: "Auditorium" },
    { id: 6, src: "images/gallery/Auditorium-6.png", alt: "Biology Lab 2", title: "Auditorium", group: "Auditorium" },
    { id: 7, src: "images/gallery/Auditorium-7.png", alt: "Auditorium", title: "Auditorium", group: "Auditorium" },
    { id: 8, src: "images/gallery/Auditorium-8.png", alt: "Auditorium", title: "Auditorium", group: "Auditorium" },
    { id: 9, src: "images/gallery/Auditorium-9.png", alt: "Auditorium", title: "Auditorium", group: "Auditorium" },
    { id: 10, src: "images/gallery/Auditorium-10.png", alt: "Auditorium", title: "Auditorium", group: "Auditorium" },
    { id: 11, src: "images/gallery/Auditorium-11.png", alt: "Auditorium", title: "Auditorium", group: "Auditorium" },
    { id: 12, src: "images/gallery/Auditorium-12.png", alt: "Auditorium", title: "Auditorium", group: "Auditorium" },    
  ];

  useEffect(() => {
    NativeFancybox.bind("[data-fancybox='gallery']", {
      infinite: true,
      Toolbar: {
        display: {
          left: ["infobar"],
          right: ["slideshow", "thumbs", "close"],
        },
      },
      Thumbs: {
        autoStart: false,
      },
      caption: (fancybox, slide) => {
        return slide.$trigger?.dataset?.caption || slide.$trigger?.title || "";
      },
    });

    return () => {
      NativeFancybox.destroy();
    };
  }, []);


  return (
    <>
      <Breadcrumb
        pageTitle="Gallery"
        breadcrumbItems={[
          { label: "Home", link: "/" },
          { label: "Auditorium" },
        ]}
        backgroundImage="images/banner/slide-2.png"
      />

      <section className="space-ptb">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 text-center">
              <div className="section-title">
                <h2>Auditorium</h2>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="my-shuffle-container row columns-4 popup-gallery full-screen">
                {images.map((image) => (
                  <div key={image.id} className="grid-item" data-group={image.group}>
                    <div className="portfolio-item">
                      <div className="position-relative">
                        <img
                          className="img-fluid"
                          src={image.src}
                          alt={image.alt}
                          loading="lazy"
                        />
                        <div className="portfolio-overlay">
                          <a
                            data-fancybox="gallery"
                            data-caption={image.title}
                            href={image.src}
                            title={image.title}
                            className="portfolio-img"
                          >
                            <i>
                              <BiPlusCircle size={40} />
                            </i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Auditorium;
